export default {
    shipperGroup: {
        overview: "Overview & AI",
        operations: "Operations",
        coordination: "Inbox & issues",
        commercial: "Commercial",
        network: "Contacts & network",
    },
    askEve: "Ask Eve",
    askEveHelpPopover: "Need help?",
    askEveHelpDismiss: "Dismiss",
    controlHub: "Control Hub",
    dashboard: "Dashboard",
    calendar: "Calendar",
    containers: "Container",
    activity: "Activity",
    issues: "Issues",
    quotes: "Quotes",
    orders: "Orders",
    receivers: "Business Partners",
    businessPartners: "Business Partners",
    shippers: "Shippers",
    team: "Team",
    addressBook: "Address Book",
    settings: "Settings",
    companies: "Companies",
    support: "Support",
    logout: "Logout",
    documents: "Documents",
    eveDrive: "Eve Drive",
    liveTracking: "Live Tracking",
    workflows: "Workflows",
    knowledgeBase: "Knowledge Base",
    analytics: "Analytics",
    reviewCenter: "Review Center",
    unreadNotifications: "{{count}} unread notifications",
};
